 import axios from 'axios'

const state = () => ({
  tadbirlar: []
})

const getters = {
  tadbirlar(state) {
    return state.tadbirlar
  }
}

const mutations = {
  SET_TADBIRLAR(state, payload){
    state.tadbirlar = payload
  },
}

const actions = {
  getTadbirlar({commit}){
    axios.get('https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/')
    .then((res)=>{
      commit("SET_TADBIRLAR", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
   getTadbirlarById({commit}, id){
    axios.get(`https://api.geomalaka.uz/api/main/kutilayotgan_tadbirlar/${id}/`)
    .then((res)=>{
      commit("SET_TADBIRLAR", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }

}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
